var _stop, _stop2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgRightBottom = function SvgRightBottom(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.05155 -7.7486e-07V6.8782C6.68041 10.9679 4.51546 13.5085 0.5567 14.5V11.5256C1.17526 11.1538 1.6701 10.7821 2.04124 10.4103C2.7835 9.54273 3.09278 8.98504 2.96907 8.73718V7.4359H0V-7.7486e-07H7.05155ZM18 -7.7486e-07V6.8782C17.3814 11.2158 15.2165 13.7564 11.5052 14.5V11.5256C12.9897 10.7821 13.7938 9.85256 13.9175 8.73718V7.4359H10.9485V-7.7486e-07H18Z",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 27,
    y1: 10.5064,
    x2: 19.9933,
    y2: -5.2841,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC73"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA81F"
  })))));
};
export default SvgRightBottom;